exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contacts-external-id{position:absolute;left:6px;bottom:10px;opacity:.5}\n", ""]);

// exports
